<template>
  <iframe
    class="col pa-0"
    width="560"
    height="315"
    :src="src"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  />
</template>

<script>
  export default {
    name: 'YoutubeFrame',
    components: {
    },
    props: {
      src: {
        type: String,
        required: true,
      },
    },
    methods: {
    },
  }
</script>
